import { OccConfig } from '@spartacus/core';

export const quotesOccContentConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        quotes: 'quotes',
        frequency: 'orderFrequency/list',
        quoteHistory: '/users/current/quotes/search?fromDate=${from}&toDate=${to}',
        quoteDetails: '/users/current/quotes/details?uid=${uid}',
        quoteAddToCart: '/orgUsers/current/carts/current/entries?quantity=${quantity}&quote=${quote}&code=${code}',
        exportToCSV: '/users/${userId}/quotes/export?fromDate=${fromDate}&toDate=${toDate}',
      },
    } as any,
  },
};
